import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

// import TopLevelTitle from './pieces/top-level-title'
import NextLevel from './pieces/next-level'

const CourseMenuChapter = (props) => {
  const [ chapter_class, setChapterClass ] = useState('top-level')

  const setClassName = () => {
    let href_list = location.href.split('/')

    if (href_list[href_list.length - 1] === '') {
      href_list.pop()
    }

    if (`/${href_list[href_list.length - 1]}` === props.module.node.url) {
      setChapterClass('top-level current')
    }
  }

  useEffect(() => {
    // setActiveUrl()
    setClassName()
  }, [])

  return (
    <div
      className={chapter_class}
    >
      {/* // Renders the TopLevel of the course menu JSON object */}
      {/* <TopLevelTitle
        className={this.props.module.node.class || false}
        icon={this.props.module.node.icon || false}
        title={this.props.module.node.title}
        url={this.props.module.node.url}
      /> */}
      {props.module.node.next_level
      && props.module.node.next_level.map((level, index) => {
        // Initial call of NextLevel.  This gets called here, and then recursively calls itself if additional next-levels exist
        return (
          <NextLevel
            authenticated={props.authenticated}
            active_url={props.location.pathname}
            key={`${level.title}-${index}`}
            level={level}
            level_number={1}
          />
        )
        })}
    </div>
  )
}

CourseMenuChapter.propTypes = {
  location: PropTypes.object.isRequired
}

export default CourseMenuChapter